var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.uploaderRecList.length
    ? _c("div", { staticClass: "vrResult blogger-scroll" }, [
        _c("h3", { staticClass: "fz-title" }, [_vm._v("\n    相关up主\n  ")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "box-scrollbar negative component_izhbdC0qdn" },
          [
            _c("div", { staticClass: "scroll-layout scroll-layout-alone" }, [
              _c(
                "div",
                { staticClass: "item-list" },
                _vm._l(_vm.uploaderRecList, function (uploader, i) {
                  return _c(
                    "a",
                    {
                      key: "uploader" + i,
                      staticClass: "item-text",
                      attrs: { href: _vm.uploaderRecUrl(uploader.author_id) },
                    },
                    [
                      _c("i", { staticClass: "img-height" }, [
                        _c("img", { attrs: { src: uploader.avatar_url } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "v-tag" }),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "item-title" }, [
                        _vm._v(_vm._s(uploader.author)),
                      ]),
                      _vm._v(" "),
                      _c("time", { staticClass: "item-time ellipsis" }, [
                        _vm._v(_vm._s(uploader.fans_num) + "粉丝"),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }